import { render, staticRenderFns } from "./Reports2AddTargetModal.vue?vue&type=template&id=08871d18&scoped=true&lang=pug&"
import script from "./Reports2AddTargetModal.vue?vue&type=script&lang=ts&"
export * from "./Reports2AddTargetModal.vue?vue&type=script&lang=ts&"
import style0 from "./Reports2AddTargetModal.vue?vue&type=style&index=0&id=08871d18&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08871d18",
  null
  
)

export default component.exports